import SharedData from "./SharedData";

export default SharedData;
